export const VM_STATUSES = {
    RUNNING: 'running',
    PENDING: 'pending',
    STOPPED: 'stopped',
    SUSPENDED: 'suspended',
    ORPHANED: 'orphaned',
    ERROR: 'error',
};
